(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const root = document.documentElement;
    let frameId = 0;
    let naturalHeight = 0;
    let railTopDocument = 0;
    let needsNaturalMeasure = true;
    let pastGrid = false;

    const getHeaderBottom = () => {
      const sectionHeader = document.querySelector('.section-header');
      if (!sectionHeader) return 0;

      const stickyHeader = sectionHeader.querySelector('sticky-header');
      const expectsSticky =
        sectionHeader.classList.contains('shopify-section-header-sticky') ||
        stickyHeader?.dataset.stickyType === 'always' ||
        stickyHeader?.dataset.stickyType === 'reduce-logo-size';

      if (expectsSticky) {
        sectionHeader.classList.add('shopify-section-header-sticky');
      }

      const style = window.getComputedStyle(sectionHeader);
      const rect = sectionHeader.getBoundingClientRect();
      const visible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.height > 0;

      if (!visible) return 0;
      if (rect.bottom > 0) return Math.max(0, Math.round(rect.bottom));
      return expectsSticky ? Math.max(0, Math.round(rect.height)) : 0;
    };

    const measureNaturalState = (shell, placeholder) => {
      const wasFixed = shell.classList.contains('is-fixed');
      const wasPastGrid = shell.classList.contains('is-past-grid');

      if (wasFixed) {
        shell.classList.remove('is-fixed', 'is-past-grid');
        placeholder.classList.remove('is-active');
        placeholder.style.height = '';
      }

      const naturalRect = shell.getBoundingClientRect();
      naturalHeight = Math.max(1, Math.round(naturalRect.height));
      railTopDocument = Math.round(naturalRect.top + window.scrollY);

      if (wasFixed) {
        shell.classList.add('is-fixed');
        if (wasPastGrid) shell.classList.add('is-past-grid');
        placeholder.classList.add('is-active');
        placeholder.style.height = `${naturalHeight}px`;
      }

      needsNaturalMeasure = false;
    };

    const update = () => {
      frameId = 0;

      const shell = document.querySelector('[data-bpc-collection-rail-shell]');
      const placeholder = document.querySelector('[data-bpc-collection-rail-placeholder]');
      const productGrid = document.getElementById('ProductGridContainer');
      const footer = document.querySelector(
        '.shopify-section-group-footer-group, footer.footer, footer'
      );
      const headerBottom = getHeaderBottom();

      root.style.setProperty('--bpc-ui-stack-height', `${headerBottom}px`);

      if (!shell || !placeholder || !productGrid) {
        root.style.setProperty('--bpc-collection-rail-height', '0px');
        return;
      }

      let isFixed = shell.classList.contains('is-fixed');

      if (!isFixed || needsNaturalMeasure || !railTopDocument) {
        measureNaturalState(shell, placeholder);
        isFixed = shell.classList.contains('is-fixed');
      }

      const railHasReachedHeader =
        window.scrollY > 24 &&
        window.scrollY + headerBottom >= railTopDocument;
      const shouldFix = railHasReachedHeader;

      if (shouldFix !== isFixed) {
        shell.classList.toggle('is-fixed', shouldFix);
        placeholder.classList.toggle('is-active', shouldFix);
        isFixed = shouldFix;
      }

      if (!shouldFix) {
        pastGrid = false;
        shell.classList.remove('is-past-grid');
        placeholder.style.height = '';
        root.style.setProperty('--bpc-collection-rail-height', `${naturalHeight}px`);
        return;
      }

      placeholder.style.height = `${naturalHeight}px`;

      const fixedHeight = Math.max(1, Math.round(shell.getBoundingClientRect().height));
      const gridBottom = productGrid.getBoundingClientRect().bottom;
      const footerTop = footer ? footer.getBoundingClientRect().top : Number.POSITIVE_INFINITY;
      const hideLine = headerBottom + fixedHeight + 12;
      const showLine = headerBottom + fixedHeight + 72;
      const viewportBottom = window.innerHeight;
      const atDocumentEnd =
        window.scrollY + window.innerHeight >=
        document.documentElement.scrollHeight - 8;
      const footerVisible = footerTop <= viewportBottom;
      const endBoundary = Math.min(gridBottom, footerTop);

      if (!pastGrid && (endBoundary <= hideLine || footerVisible || atDocumentEnd)) {
        pastGrid = true;
      } else if (
        pastGrid &&
        endBoundary >= showLine &&
        footerTop > viewportBottom + 72 &&
        !atDocumentEnd
      ) {
        pastGrid = false;
      }

      shell.classList.toggle('is-past-grid', pastGrid);
      root.style.setProperty(
        '--bpc-collection-rail-height',
        pastGrid ? '0px' : `${fixedHeight}px`
      );
    };

    const schedule = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(update);
    };

    const scheduleNaturalMeasure = () => {
      needsNaturalMeasure = true;
      schedule();
    };

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      document
        .querySelectorAll(
          '.section-header, [data-bpc-collection-rail-shell], [data-bpc-collection-rail-placeholder], #ProductGridContainer, .shopify-section-group-footer-group, footer.footer'
        )
        .forEach((element) => observer.observe(element));
    }

    window.addEventListener('resize', scheduleNaturalMeasure, { passive: true });
    window.addEventListener('orientationchange', scheduleNaturalMeasure, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('shopify:section:load', scheduleNaturalMeasure);
    document.addEventListener('shopify:section:reorder', scheduleNaturalMeasure);
    document.addEventListener('shopify:section:select', scheduleNaturalMeasure);

    scheduleNaturalMeasure();
  });
})();